import React from 'react';
import { styles } from './styles';
import { Box, Typography, Button } from '@mui/material';
import SignalWifiOffIcon from '@mui/icons-material/SignalWifiOff';

const NoInternetPage = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Box sx={styles.root}>
      <SignalWifiOffIcon sx={styles.icon} />
      <Typography variant="h4" gutterBottom>
        No Internet Connection
      </Typography>
      <Typography variant="body1" sx={styles.description}>
        It looks like you're offline. Please check your network settings.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleRetry}
        sx={styles.button}
      >
        Retry
      </Button>
    </Box>
  );
};

export default NoInternetPage;
